import { generateCanvasId } from "../../../lib/canvas-id";
import { navigate } from "../../../router";

interface Props {
  readonly canvasId: string;
}

// 左上のフローティングアプリメニュー。
// - TOP（ダッシュボード）へ戻る
// - 新規キャンバスを作成して /c/<newId> へ遷移
export function AppMenu({ canvasId: _canvasId }: Props): JSX.Element {
  return (
    <div
      style={{
        position: "absolute",
        top: "16px",
        left: "16px",
        display: "flex",
        gap: "8px",
        background: "var(--color-surface)",
        padding: "8px",
        borderRadius: "var(--radius-2)",
        border: "1px solid var(--color-border)",
        boxShadow: "var(--shadow-1)",
        zIndex: 10,
      }}
    >
      <button
        type="button"
        onClick={() => navigate("/")}
        aria-label="ダッシュボードへ戻る"
      >
        ↑ TOP
      </button>
      <button
        type="button"
        onClick={() => navigate(`/c/${generateCanvasId()}`)}
        aria-label="新規キャンバスを作成"
      >
        + 新規
      </button>
    </div>
  );
}
